import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND, FOOTER_LINKS } from "@/lib/content";

export const SiteFooter = () => {
  return (
    <footer className="bg-[var(--hp-charcoal)] text-white/80">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-[var(--hp-crimson)] font-display text-base text-white">
                HP
              </span>
              <span className="font-display text-lg text-white">{BRAND.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed">
              Discreet and secure packaging. 100% pure Ayurvedic formula.
            </p>
          </div>

          {Object.entries(FOOTER_LINKS).map(([title, links]) => (
            <div key={title}>
              <h3 className="font-bold text-white">{title}</h3>
              <ul className="mt-4 space-y-2 text-sm">
                {links.map((l) => (
                  <li key={l}>
                    <a
                      href="#"
                      data-testid={`footer-link-${l}`}
                      className="hover:text-white"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="font-bold text-white">Contact Us</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="mt-0.5 h-4 w-4 text-[var(--hp-gold-light)]" />
                <a href={`tel:${BRAND.phone}`} data-testid="footer-phone">
                  {BRAND.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="mt-0.5 h-4 w-4 text-[var(--hp-gold-light)]" />
                <a href={`mailto:${BRAND.email}`} data-testid="footer-email">
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 text-[var(--hp-gold-light)]" />
                <span>{BRAND.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 text-center text-xs text-white/50">
          <p>
            This product is an Ayurvedic supplement and is not intended to diagnose, treat, cure,
            or prevent any disease. Results may vary from person to person.
          </p>
          <p className="mt-3">© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
